import { i18n } from '@/plugins/i18n'
import { customerStatusVariant, customerStatusStr } from "@/constants/customerStatus";


export default [
    {
        field: 'id',
        title: i18n.t('online-factor.hash_id'),
        sortable: false,
        width: 40,
        textAlign: 'center',
    },
    {
        field: 'code',
        title: i18n.t('online-factor.discount_code'),
        sortable: false,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'discount_percent',
        title: i18n.t('online-factor.discount_percent'),
        sortable: false,
        template: (row) => {
            return '<span dir="ltr">' + row.discount_percent + '%'  + '</span>'
        },
        width: 60,
        textAlign: 'center',
    },
    {
        field: 'min_purchase_amount',
        title: i18n.t('online-factor.min_purchase_amount'),
        template: (row) => {
            return '<span dir="ltr">' + row.min_purchase_amount.toLocaleString() + '</span>'
        },
        sortable: false,
        textAlign: 'center',
        width: 80,
    },
    {
        field: 'max_discount_amount',
        title: i18n.t('online-factor.max_discount_amount'),
        template: (row) => {
            return '<span dir="ltr">' + row.max_discount_amount.toLocaleString() + '</span>'
        },
        sortable: true,
        textAlign: 'center',
        width: 90,
    },
    {
        field: 'expires_at',
        title: i18n.t('online-factor.expires_at'),
        template: (row) => {
            return '<span dir="ltr">' + (row.expires_at || '-') + '</span>'
        },
        sortable: false,
        textAlign: 'center',
        width: 80,
    },
]
